import { render, staticRenderFns } from "./LeadershipPlus.vue?vue&type=template&id=dcb48b0a&scoped=true&"
import script from "./LeadershipPlus.vue?vue&type=script&lang=js&"
export * from "./LeadershipPlus.vue?vue&type=script&lang=js&"
import style0 from "./LeadershipPlus.vue?vue&type=style&index=0&id=dcb48b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb48b0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
